import { render } from "./TwoFactorConfirm.vue?vue&type=template&id=20a88c43&scoped=true"
import script from "./TwoFactorConfirm.vue?vue&type=script&lang=ts"
export * from "./TwoFactorConfirm.vue?vue&type=script&lang=ts"

import "./TwoFactorConfirm.vue?vue&type=style&index=0&id=20a88c43&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20a88c43"

export default script